import React from 'react';
import queryString from 'query-string';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { externalLogin } from '../../redux/actions/AuthenticationActions';
import { getSystemSettings } from '../../redux/actions/SettingsActions';
import { updateGeosuggestLanguageSettings } from '../../redux/actions/UtilsActions';

import IdleTimer from './IdleTimer';
import LoadingSpinner from '../commonComponents/util/LoadingSpinner';
import { Helmet } from 'react-helmet';
import ExternalCampaignListPage from '../campaignComponents/externalLists/ExternalCampaignListPage';

class ExternalUserContainer extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            ready: false,
            authenticated: false
        };
    }

    componentWillMount() {
        this.login();
    }

    async login() {
        await this.props.actions.externalLogin(queryString.parse(this.props.location.search).token);
        if (this.props.login.success)
            await this.props.actions.getSystemSettings();

        this.setState({
            ready: true,
            authenticated: this.props.login.success
        });
    }

    handleScriptInject({ scriptTags }) {
        if (scriptTags) {
            if (window.google) window.google = undefined;
            this.props.actions.updateGeosuggestLanguageSettings({ loading: true });
            const scriptTag = scriptTags[0];
            scriptTag.onload = this.handleOnLoad.bind(this);
        }
    }

    handleOnLoad(script) {
        this.props.actions.updateGeosuggestLanguageSettings({ loading: false });
    }

    render() {
        return (
            <div className="secondary-page secretary-page">
                <Helmet defer={false} onChangeClientState={(newState, addedTags) => this.handleScriptInject(addedTags)}>
                    <script async={false} type="text/javascript" src={`https://maps.googleapis.com/maps/api/js?key=${process.env.REACT_APP_GOOGLE_API_KEY}&libraries=places${this.props.utils.geosuggestLanguageSettings.language ? `&language=${this.props.utils.geosuggestLanguageSettings.language}` : ''}`} />
                </Helmet>
                {!this.state.ready ? <div className="page"><LoadingSpinner height="35" /></div> :
                    (!this.state.authenticated ?
                        <div className="full-page-empty-state">
                            <img src="/images/logo.png" alt="logo" />
                            <p>This page is unavailable.  Please reach out to your SFTF contact to receive a new link to view your campaign list.</p>
                        </div> : <IdleTimer alwaysRefresh={true}
                            logout={() => this.setState({ authenticated: false })} refreshUrl="/account/refreshExternalToken">
                            <ExternalCampaignListPage
                                token={queryString.parse(this.props.location.search).token}
                                campaignListId={this.props.match.params.id} />
                        </IdleTimer>)
                }
            </div>
        );
    }
}

function mapStateToProps(state, ownProps) {
    return {
        login: state.authentication.login,
        utils: state.utils
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators({ externalLogin, getSystemSettings, updateGeosuggestLanguageSettings }, dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(ExternalUserContainer);


// WEBPACK FOOTER //
// ./src/components/layoutComponents/ExternalUserContainer.jsx